import {QTableColumn} from 'pansx-utils';

export class QingApp {
    public id?: number;
    public customerId = 0;
    public appName = '';
    public appSecret = '';
    public signKey = '';
    public description = '';
    public logo = '';
    public showType = 0;
    public showUser: string[] = [];
    public showCustomer: string[] = [];
    public showRole: string[] = [];
    public mobileUrl = '';
    public webUrl = '';
    public desktopUrl = '';
    public valid?: boolean;
    public userName?: string;
    public lightAppSort = '';
    public companyId  = '';
    public userIdentity?: string;
    public companyCreditCode?: string;
    
    public static of(o: unknown): QingApp {
        return Object.assign(new QingApp(), o);
    }
    
    public static getColumns(): QTableColumn[] {
        return [
            {name: 'id', field: 'id', label: '轻应用id'},
            {name: 'appName', field: 'appName', label: '轻应用名'},
            {name: 'appSecret', field: 'appSecret', label: '轻应用密钥'},
            {name: 'signKey', field: 'signKey', label: '签名密钥'},
            {name: 'description', field: 'description', label: '描述'},
            {name: 'logo', field: 'logo', label: '图标'},
            {name: 'showType', field: 'showType', label: '显示类型'},
            {name: 'showUser', field: 'showUser', label: '可见用户'},
            {
                name: 'showCustomer',
                field: 'showCustomer',
                label: '可见用户组',
            },
            {name: 'showRole', field: 'showRole', label: '可见角色'},
            {name: 'mobileUrl', field: 'mobileUrl', label: '移动url'},
            {name: 'webUrl', field: 'webUrl', label: '跳转地址'},
            {name: 'desktopUrl', field: 'desktopUrl', label: '桌面url'},
            {name: 'valid', field: 'valid', label: '有效的'},
        ];
    }
    
    public getColumnLabel(field: string) {
        const columns = QingApp.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field,
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
